/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import { defineMessages } from 'react-intl';

export const batchBladeMessages = defineMessages({
    singleTestPanel: {
        id: 'testPane.batchBlade.singleTestPanel',
        defaultMessage: 'Single testing panel'
    },
    singleTestPanelAriaLabel: {
        id: 'testPane.batchBlade.singleTestPanelAriaLabel',
        defaultMessage: 'Open single testing panel'
    },
    importModalTitle: {
        id: 'testPane.batchBlade.importModalTitle',
        defaultMessage: 'Import dataset'
    },
    importModalSample: {
        id: 'testPane.batchBlade.importModalSample',
        defaultMessage: 'Learn more about allowed dataset syntax'
    },
    deleteModalTitle: {
        id: 'testPane.batchBlade.deleteModalTitle',
        defaultMessage: 'Delete dataset(s)?'
    },
    deleteDatasetBody: {
        id: 'testPane.batchBlade.deleteDatasetBody',
        defaultMessage: 'Are you sure you want to delete the selected dataset(s)?'
    },
    renameModalTitle: {
        id: 'testPane.batchBlade.renameModalTitle',
        defaultMessage: 'Rename dataset'
    },
    importingRunning: {
        id: 'testPane.batchBlade.importingRunning',
        defaultMessage: 'Importing dataset...'
    },
    importingComplete: {
        id: 'testPane.batchBlade.importingComplete',
        defaultMessage: 'Importing dataset completed'
    },
    importingFailing: {
        id: 'testPane.batchBlade.importingFailing',
        defaultMessage: 'Importing dataset failed'
    },
    deletingRunning: {
        id: 'testPane.batchBlade.deletingRunning',
        defaultMessage: 'Deleting dataset...'
    },
    deletingComplete: {
        id: 'testPane.batchBlade.deletingComplete',
        defaultMessage: 'Deleting dataset completed'
    },
    deletingFailing: {
        id: 'testPane.batchBlade.deletingFailing',
        defaultMessage: 'Deleting dataset failed'
    },
    renamingRunning: {
        id: 'testPane.batchBlade.renamingRunning',
        defaultMessage: 'Renaming dataset...'
    },
    renamingComplete: {
        id: 'testPane.batchBlade.renamingComplete',
        defaultMessage: 'Renaming dataset completed'
    },
    renamingFailing: {
        id: 'testPane.batchBlade.renamingFailing',
        defaultMessage: 'Renaming dataset failed'
    }
});
